import React, { PureComponent } from "react";
import Navigation from "./Components/Navigation";
import Footer from "./Components/Footer";
import Appmain from "./Components/Appmain";
import "./index.css";

class App extends PureComponent {
  render() {
    return (
	<div>
	<Navigation/>
	<div className="content">
	<Appmain/>
	</div>
	<Footer/>
	</div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js